<template>
  <div class="m-auto">
    <div v-if="!isParticipantAgreed && !onEligibleToJoin" class="eulaContainer pt-48">
      <div class="eula-text-box cursor-contextMenu">
        <div v-html="licenseDescription"></div>
      </div>
      <div class="row activation-btn-group">
        <div class="col-6 col-md-6">
          <button class="btn leavestudy" data-toggle="modal" data-target="#disagreeModal" v-translate:DISAGREE="lang">
            Disagree
          </button>
        </div>
        <div class="col-6 col-md-6">
          <button class="btn leave_study_cntue primary-bg" data-toggle="modal" data-target="#agreeModal" v-translate:AGREE_TEXT="lang">
            Agree
          </button>
        </div>
      </div>
    </div>

    <div class="modal fade" id="disagreeModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg m-10" role="document">
        <div class="modal-content">
          <div class="modal-body modal-padding">
            <div class="verification text-center">
              <label class="verify-name p-0 m-0" v-translate:CONSENT_REVIEW_ALERT_TITLE="lang">Review</label>
              <p class="edu-consent-text" v-translate:eula_disagree="lang">
                You must agree to the Terms of Use agreement to be able to participate in this study.
              </p>
            </div>
            <div class="row pt-30 agree-btn-group">
              <div class="col-6 col-md-6 pl-0">
                <button data-dismiss="modal" class="btn leavestudy" v-translate:label_cancel="lang">
                  Cancel
                </button>
              </div>
              <div class="col-6 col-md-6 pr-0 discard-btn">
                <button class="btn leave_study_cntue primary-bg" data-dismiss="modal" @click="notAgree" v-translate:DISAGREE="lang">
                  Disagree
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="agreeModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg m-10" role="document">
        <div class="modal-content">
          <div class="modal-body modal-padding">
            <div class="verification text-center">
              <label class="verify-name p-0 m-0" v-translate:CONSENT_REVIEW_ALERT_TITLE="lang">Review</label>
              <p class="edu-consent-text" v-translate:eula_agree="lang">
                By clicking agree, you agree to be bound by our Terms of use agreement.
              </p>
            </div>
            <div class="row pt-30 agree-btn-group">
              <div class="col-6 col-md-6 pl-0">
                <button data-dismiss="modal" class="btn leavestudy" v-translate:label_cancel="lang">
                  Cancel
                </button>
              </div>
              <div class="col-6 col-md-6 pr-0 discard-btn">
                <button class="btn leave_study_cntue primary-bg" data-dismiss="modal" @click="agreed" v-translate:AGREE_TEXT="lang">
                  Agree
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="onEligibleToJoin">
      <div class="consent-education-4 common-consent-edu">
        <div class="text-center">
          <img :src="getStudyIcon" alt="" class="edu-green-check" />
        </div>
        <p class="verify-name m-0" v-translate:YOU_ARE_ELIGIBLE_TO_JOIN_STUDY="lang">
          You are eligible to join this study!
        </p>
        <p class="edu-consent-text m-0" v-translate:ELIGIBLE_FOR_THE_STUDY_INFO_TEXT="lang">
          You are eligible to participate in this study. Tap the button below to be guided through the research activities and responsibilities.
        </p>
        <div class="text-center pt-42 ml-15 mr-15">
          <button class="btn btn-submit primary-bg" @click="onOpenEnrollment" v-translate:START_BUTTON_TITLE="lang">
            Start
          </button>
        </div>
      </div>
    </div>
    <div v-if="isParticipantAgreed" class="email-verification text-center">
      <p class="m-0 verify-name" v-translate:verify_title="lang">Verify</p>
      <p class="m-0 verify-email-text text-color cursor-contextMenu" v-translate:verify_text="lang">
        Please verify that this information below is correct
      </p>
      <p class="m-0 verify-email-text primary-text pb-8 cursor-contextMenu">
        {{ userVerificationTitle }}
      </p>
      <p v-if="this.participantData && this.participantData.isPhoneVerification" class="m-0 verify-email-text primary-text cursor-contextMenu">
        {{ userPhone | national | trim0 }}
      </p>
      <p v-else class="m-0 verify-email-text primary-text cursor-contextMenu">
        {{ userEmail }}
      </p>
      <div class="text-center pt-48 pb-24 pl-20 pr-20">
        <button class="btn btn-submit primary-bg" @click="detailsAreCorrect" v-translate:label_correct="lang">
          Correct
        </button>
      </div>
      <span class="m-0 verify-email-text primary-text cursor-pointer" v-translate:THIS_IS_NOT_ME_BUTTON_TITLE="lang" data-toggle="modal" data-target="#verifyModal">This is not me</span>
    </div>

    <div class="modal fade" id="verifyModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg m-10" role="document">
        <div class="modal-content">
          <div class="modal-body modal-padding">
            <div class="verification text-center">
              <p class="language-title p-0 m-0" v-html="thisIsNotMeText"></p>
            </div>
            <div :class="participantData.isPhoneVerification ? 'row pt-30' : 'row pt-30 agree-btn-group'">
              <div class="col-6 col-md-6 pl-0">
                <button v-if="!participantData.isPhoneVerification" data-dismiss="modal" class="btn leavestudy" v-translate:label_cancel="lang">
                  Cancel
                </button>
              </div>
              <div :class="participantData.isPhoneVerification ? 'col-12 col-md-12 pr-0 discard-btn' : 'col-6 col-md-6 pr-0 discard-btn'">
                <button class="btn leave_study_cntue primary-bg" :class="participantData.isPhoneVerification ? 'btn-submit' : ''" data-dismiss="modal" @click="notAgree('onNotMe')" v-translate:label_ok="lang">
                  Ok
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Bitrise, Widget, ParticipantPortal, Participant, Consent } from "@/components/services/participant-service";
export default {
  name: "join-eula",
  components: {},
  props: ["isOnBackClick", "lang", "listOfCohorts", "eligibilityQuestionsAns"],
  data() {
    return {
      widget: new Widget(),
      portal: new ParticipantPortal(),
      bitrise: new Bitrise(),
      participantData: new Participant(),
      consent: new Consent(),
      isParticipantAgreed: false,
      isDisagree: false,
      licenseDescription: "",
      onEligibleToJoin: false,
      listOfCohart: [],
      isDatavantEnabledForStudy: false
    };
  },
  computed: {
    ...mapGetters(["participant"]),
    globalElements() {
      return this.$store.getters.getParticipantsPortalGlobalElements;
    },
    userPhone() {
      return this.participantData.getParticipantPhoneE164();
    },
    userEmail() {
      return this.participantData.getParticipantEmail();
    },
    thisIsNotMeText() {
      return this.participantData.isPhoneVerification ? this.widget.translate("label_hey_not_my_number", "Please contact your study team to <br/>correct your <br/>Verification Phone Number.") : this.widget.translate("label_hey_not_me", "Please contact your study physician to be issued a new code");
    },
    study() {
      return this.$store.getters.getParticipantsPortalStudyData;
    },
    translations() {
      return this.$store.getters.getParticipantsPortalStrings;
    },
    dynamicLicenseDescription() {
      return this.translations && this.translations[this.study.id + "_license_html"] ? this.translations[this.study.id + "_license_html"] : this.widget.i18nActivities(`${this.study.id}_license_html`, this.lang) ? this.widget.i18nActivities(`${this.study.id}_license_html`, this.lang) : false;
    },
    getStudyIcon() {
      return this.bitrise.getImage("tintedlogo");
    },
    userVerificationTitle() {
      return this.participantData.isPhoneVerification ? this.widget.translate("label_verification_phone_number", "Verification Phone Number") : this.widget.translate("email", "Email");
    }
  },
  watch: {
    isOnBackClick(val) {
      if (val) {
        this.$emit("backButtonClicked", "isReadyToJoinStudy");
      }
    },
    translations(val) {
      if (val) {
        this.getLicenseDescription();
      }
    }
  },
  mounted() {
    this.$emit("updateHeaderNav", {
      showBlankHeader: true,
      title: this.widget.translate("eula_document_name", "Thread Study Application End User License Agreement")
    });
    this.getLicenseDescription();
    this.getListOfcohort();
  },
  methods: {
    replaceHtmlTag(format, content) {
      this.licenseDescription = this.licenseDescription.replace(format, content);
      return this.licenseDescription;
    },
    getLicenseDescription() {
      if ((this.lang !== "en" || this.lang !== "EN") && this.dynamicLicenseDescription) {
        this.licenseDescription = this.dynamicLicenseDescription.replace("\\'center\\'", "center");
        this.licenseDescription = this.replaceHtmlTag(/\\'/g, "'");
        this.licenseDescription = this.replaceHtmlTag(/\/r/g, "r");
        this.licenseDescription = this.replaceHtmlTag(/\/i/g, "i");
        this.licenseDescription = this.replaceHtmlTag(/\\t/g, "");
      } else {
        this.bitrise.getHTML("license").then(
          res => {
            this.licenseDescription = res;
          },
          error => {
            const message = this.widget.translate(error.message, "Data sync failed, please try again after some time.");
            if (message) {
              this.$toastr.error(message);
            }
          }
        );
      }
    },
    getListOfcohort() {
      this.consent.getCohartData().then(res => {
        this.listOfCohart = res;
        this.$emit("onChangeCohorts", res);
      });
    },
    onOpenEnrollment() {
      const payload = {
        onBoardingData: this.eligibilityQuestionsAns
      };
      this.$api
        .saveEligibility(payload)
        .then(res => {
          const message = this.widget.translate(res.message_key, "All OnBoarding responses are stored!!!");
          if (message) {
            this.$toastr.success(message);
          }
          this.$emit("updateActiveScreen", "isCohortCompleted");
        })
        .catch(err => {
          const message = this.widget.translate(err.message, "Unable to save OnBoarding responses Please try after some time");
          if (message) {
            this.$toastr.error(message);
          }
        });
    },
    agreed() {
      if (this.portal.isOpenEnrollmentStudy()) {
        this.onEligibleToJoin = true;
        this.$emit("updateHeaderNav", {
          showBlankHeader: true,
          title: this.widget.translate("label_eligibility", "Eligibility")
        });
      } else {
        this.isParticipantAgreed = true;
        this.$emit("updateHeaderNav", {
          showBlankHeader: true,
          hideBack: true,
          title: this.widget.translate("verify_title", "Verify")
        });
      }
    },
    notAgree() {
      this.$emit("updateActiveScreen", "joinIntro");
    },
    detailsAreCorrect() {
      if (this.study.consentEnabled) {
        if (this.listOfCohart && this.listOfCohart.length > 1) {
          this.$emit("updateActiveScreen", "isCohortCompleted");
        } else {
          this.$emit("updateActiveScreen", "isDetailsCorrect");
        }
      } else {
        this.$emit("updateActiveScreen", "isConcentSignCompleted");
      }
    }
  }
};
</script>

<style>
#disagreeModal .modal-body,
#agreeModal .modal-body,
#disagreeModal1 .modal-body,
#agreeModal1 .modal-body,
#verifyModal .modal-body {
  padding: 48px;
}
#disagreeModal .modal-dialog,
#agreeModal .modal-dialog,
#disagreeModal1 .modal-dialog,
#agreeModal1 .modal-dialog,
#verifyModal .modal-dialog {
  max-width: 500px;
}
#disagreeModal .agree-btn-group,
#agreeModal .agree-btn-group,
#disagreeModal1 .agree-btn-group,
#agreeModal1 .agree-btn-group,
#verifyModal .agree-btn-group {
  margin: 0 50px !important;
}
.eula-box {
  width: 629px;
  height: 596px;
}
.email-verification-box {
  width: 454px;
  height: 361.2px;
}
.modal-dialog {
  min-width: 540px !important;
}
</style>
